import { Link } from 'react-router-dom';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'The Future of AI in Business Automation',
      excerpt: 'Discover how artificial intelligence is transforming the way businesses operate and compete in the digital age.',
      category: 'AI & Automation',
      date: 'Jan 5, 2026',
      readTime: '5 min read',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&auto=format&fit=crop',
      author: 'FIGO Team',
      slug: 'future-of-ai-business-automation'
    },
    {
      id: 2,
      title: 'Building Scalable Web Applications in 2026',
      excerpt: 'Learn the best practices and modern technologies for creating web applications that scale with your business growth.',
      category: 'Software Development',
      date: 'Dec 28, 2025',
      readTime: '7 min read',
      image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&auto=format&fit=crop',
      author: 'FIGO Team',
      slug: 'building-scalable-web-applications'
    },
    {
      id: 3,
      title: 'Digital Transformation: A Complete Guide for Nigerian Businesses',
      excerpt: 'Everything you need to know about successfully implementing digital transformation in your organization.',
      category: 'Digital Transformation',
      date: 'Dec 20, 2025',
      readTime: '10 min read',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&auto=format&fit=crop',
      author: 'FIGO Team',
      slug: 'digital-transformation-guide-nigerian-businesses'
    }
  ];

  return (
    <section style={{
      padding: '6rem 5%',
      background: 'var(--dark-surface)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background decoration */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(37, 99, 235, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>

      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <p style={{
            color: 'var(--figo-secondary)',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '3px',
            marginBottom: '1rem',
            fontWeight: '600',
            opacity: 0.8
          }}>
            Insights & Updates
          </p>
          <h2 style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            marginBottom: '1rem',
            background: 'var(--gradient-1)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: '700',
            lineHeight: '1.2'
          }}>
            Latest from Our Blog
          </h2>
          <p style={{
            color: 'var(--light-text)',
            fontSize: '1.1rem',
            maxWidth: '700px',
            margin: '0 auto',
            opacity: 0.8
          }}>
            Stay updated with the latest trends, insights, and best practices in digital transformation and technology.
          </p>
        </div>

        {/* Blog Grid */}
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '2rem',
            marginBottom: '3rem'
          }}
        >
          {blogPosts.map((post) => (
            <article
              key={post.id}
              style={{
                background: 'rgba(255, 255, 255, 0.02)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '20px',
                overflow: 'hidden',
                transition: 'transform 0.3s ease, boxShadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.borderColor = 'var(--figo-primary)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(37, 99, 235, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Post Image */}
              <div style={{
                height: '250px',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <img
                  src={post.image}
                  alt={post.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.5s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                />
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 100%)'
                }}></div>
              </div>

              {/* Post Content */}
              <div style={{ padding: '1.5rem' }}>
                {/* Category & Date */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '1rem',
                  flexWrap: 'wrap',
                  gap: '0.5rem'
                }}>
                  <span style={{
                    color: 'var(--figo-secondary)',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '1.5px',
                    fontWeight: '600'
                  }}>
                    {post.category}
                  </span>
                  <span style={{
                    color: 'var(--muted-text)',
                    fontSize: '0.8rem'
                  }}>
                    {post.date}
                  </span>
                </div>

                {/* Title */}
                <h3 style={{
                  fontSize: '1.35rem',
                  color: 'var(--light-text)',
                  marginBottom: '0.75rem',
                  fontWeight: '700',
                  lineHeight: '1.4'
                }}>
                  {post.title}
                </h3>

                {/* Excerpt */}
                <p style={{
                  color: 'var(--muted-text)',
                  fontSize: '0.95rem',
                  lineHeight: '1.6',
                  marginBottom: '1.5rem'
                }}>
                  {post.excerpt}
                </p>

                {/* Meta Info */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingTop: '1rem',
                  borderTop: '1px solid rgba(255, 255, 255, 0.05)'
                }}>
                  <span style={{
                    color: 'var(--light-text)',
                    fontSize: '0.85rem',
                    opacity: 0.7
                  }}>
                    {post.author}
                  </span>
                  <span style={{
                    color: 'var(--figo-secondary)',
                    fontSize: '0.85rem',
                    fontWeight: '600'
                  }}>
                    {post.readTime}
                  </span>
                </div>

                {/* Read More Link */}
                <div style={{
                  marginTop: '1.25rem'
                }}>
                  <Link
                    to={`/blog/${post.slug}`}
                    style={{
                      color: 'var(--figo-primary)',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      transition: 'gap 0.3s ease, color 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.gap = '0.75rem';
                      e.currentTarget.style.color = 'var(--figo-secondary)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.gap = '0.5rem';
                      e.currentTarget.style.color = 'var(--figo-primary)';
                    }}
                  >
                    Read Article <span>→</span>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* View All Button */}
        <div style={{ textAlign: 'center' }}>
          <Link
            to="/blog"
            style={{
              display: 'inline-block',
              padding: '1rem 2.5rem',
              background: 'transparent',
              border: '2px solid var(--figo-secondary)',
              borderRadius: '50px',
              color: 'var(--figo-secondary)',
              fontSize: '1rem',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'transform 0.3s ease, boxShadow 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--gradient-2)';
              e.currentTarget.style.borderColor = 'transparent';
              e.currentTarget.style.color = 'white';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 5px 15px rgba(31, 207, 159, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = 'var(--figo-secondary)';
              e.currentTarget.style.color = 'var(--figo-secondary)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            View All Articles
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog;
